import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {NbtipsComponent} from "./nbtips.component";

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [NbtipsComponent],
  exports: [NbtipsComponent],
})
export class NbtipsModule {}
